import { motion } from "framer-motion";
import { formatMoney } from "../lib/site.js";

export default function ProductGrid({ products, cta, onSelect }) {
  return (
    <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-4">
      {products.map((product, index) => (
        <motion.article
          key={product.id}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.04 }}
          className="premium-card flex min-h-[300px] flex-col p-5 transition hover:-translate-y-1 hover:shadow-premiumHover"
        >
          {product.isFeatured && <span className="mb-3 w-fit rounded-full bg-gold px-3 py-1 text-xs font-black text-ink">Featured</span>}
          <h2 className="text-xl font-black text-royal">{product.name}</h2>
          <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
            <div className="rounded-sur bg-ivory p-3">
              <span className="text-muted">Rate</span>
              <strong className="block text-lg text-maroon">{product.interestRate}%</strong>
            </div>
            <div className="rounded-sur bg-[var(--surface-soft)] p-3">
              <span className="text-muted">Minimum</span>
              <strong className="block text-sm text-ink">{minimumLabel(product)}</strong>
            </div>
          </div>
          <ul className="mt-4 grid gap-2 text-sm leading-6 text-muted">
            {product.features.map((feature) => (
              <li key={feature}>✓ {feature}</li>
            ))}
          </ul>
          <button
            className="focus-ring mt-auto rounded-sur bg-royal px-4 py-3 text-sm font-black text-white"
            onClick={() => onSelect(product)}
          >
            {cta}
          </button>
        </motion.article>
      ))}
    </div>
  );
}

function minimumLabel(product) {
  if (product.minimumGoldGrams) return `${product.minimumGoldGrams} grams`;
  return formatMoney(product.minimumDeposit || product.minimumMonthlyDeposit || product.minimumDailyDeposit || 0);
}
